import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-start", this.showSpinner.bind(this));
  }

  showSpinner() {
    const spinner = document.querySelector(".voyager-loading-overlay");
    if (spinner) {
      const clonedSpinner = spinner.cloneNode(true);
      clonedSpinner.classList.add("d-flex");
      document.body.appendChild(clonedSpinner);
    }
  }
}
